import { useEffect, useMemo, useState } from "react";
import { Button, Col, Container, Dropdown, DropdownButton, Form, Row } from "react-bootstrap";
import styles from "./addStaff.module.scss";
// img
import { useNavigate, useParams } from "react-router-dom";
import { FieldArray, Formik } from "formik";
import LoadingIndicator from "components/shared/LoadingIndicator";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { dateFormat, dobFormat, errorMessageToast, getAge, getPdfBlob, successMessageToast, userFullName } from "helpers/common";
import LoadingButton from "components/shared/LoadingButton";
import moment from "moment";
// import ReportError from "components/shared/ReportsV2/ReportError";
import AppDatePicker from "components/shared/FormComponents/AppDatePicker";
import { useSelector } from "react-redux";
import CustomEditor from "components/TipTapEditor/CustomeEditor";
// import { schoolDischargeScreeningValidationSchema } from "./validation";
import threDots_img from "Assets/images/three-dots.png"
import date_img from "Assets/images/date.png"
import { AppSelect2Field } from "components/shared/FormComponents/AppSelect2Field";
import GuardianDetailList from "../../../../../components/Reports/GuardianDetailsList";
import ViewPdfModal from "components/Modals/ViewPdfModal";
import IntakePdfDocV2 from "./IntakePdfDoc";
import { useCreateIntakeReportMutation, useGetHomeEducationClientDetailsQuery, useGetHomeEducationIntakeDetailsQuery } from "store/services/clients/homeEducation.client";
import { useUploadFileMutation } from "store/services/utility";
import { ReportsNoRecordMessage } from "components/Common/Common";
import { VIEW_HOME_EDUCATION } from "config/paths";
import intakeFormSchema from "./intake.schema";
import PdfPublishModal from "components/Modals/PdfPublishModal";
import AppInputField from "components/shared/FormComponents/AppInputField";



const IntakeReportV2 = () => {
    const navigate = useNavigate();
    const [previewMode, setPreviewMode] = useState(false)
    const [submitting, setSubmitting] = useState(false)
    const [pdfModal, setPdfModal] = useState(false)
    const [document, setDocument] = useState(null)
    const { id: clientId } = useParams();
    const clientType = "home_education"
    const [initialValues, setInitialValues] = useState({})
    const [publishPdfModal, setPublishPdfModal] = useState(false)

    const [uploadFile, { isLoading: isUploading }] = useUploadFileMutation()
    const { data, isLoading, refetch, isError, isFetching } = useGetHomeEducationClientDetailsQuery(clientId);
    const { data: intakeData, isFetching: intakeDataFetching, isLoading: intakeDataLoading } = useGetHomeEducationIntakeDetailsQuery(clientId);
    const [createReport, { isLoading: createReportLoading }] = useCreateIntakeReportMutation();

    const handleSubmitStep = async (values) => {
        setSubmitting(true);

        try {
            let body = {}
            if (values?.saveForLater) {
                body = {
                    parent_report: values?.parent_report,
                    recommendations: values?.recommendations,
                    parent: values?.parent,
                    save_for_later: "yes",
                    attachment_key: "dummy",
                    attachment_name: "dummy",
                    date_of_intake: values?.date_of_intake,
                }
            }

            else {
                const selectedGuardians = data?.client_detail?.client_guardian_mapping?.length > 0 &&
                    [...data.client_detail.client_guardian_mapping]
                        .map((guardian) => {
                            const id = guardian?.client_guardian?.id;
                            const role = guardian?.client_guardian?.client_role?.title;

                            const matchedGuardian = values?.parent?.find(
                                (item) => item?.parent_id === id
                            );

                            if (matchedGuardian) {
                                return {
                                    ...guardian,
                                    key: matchedGuardian?.role  // or matchedGuardian.role
                                };
                            }
                            return null;
                        })
                        .filter(Boolean);

                const pdfData = {
                    lastname: data?.lastname,
                    firstname: data?.firstname,
                    city_town: data?.client_detail?.city_town,
                    dob: dateFormat(data?.client_detail?.dob, dobFormat),
                    age: getAge(data?.client_detail?.dob),
                    grade: data?.client_detail?.grade,
                    reportAreas: values?.screening_results,
                    schoolName: data?.client_detail?.client_school_detail?.client_school?.name,
                    schoolLocation: data?.client_detail?.client_school_detail?.client_school?.location,
                    selectedGuardians,
                    reportDate: moment(new Date()).format("MMMM D, YYYY"),
                    parent_report: values?.parent_report,
                    recommendations: values?.recommendations,
                    date_of_intake: values?.date_of_intake,
                }

                const doc = (
                    <IntakePdfDocV2
                        data={pdfData}
                    />
                )

                const filename = `Home Education Intake Form ${moment(new Date()).format("YYYY-MM-DD")}.pdf`
                let pdfFile = await getPdfBlob(doc, false, filename);

                let uploadedFileName = await uploadFile({ file: pdfFile, acl: "private", fileOriginalFormat: true }).unwrap();

                if (!uploadedFileName) {
                    throw new Error("File not uploaded");
                };

                body = {
                    parent_report: values?.parent_report,
                    recommendations: values?.recommendations,
                    parent: values?.parent,
                    save_for_later: "no",
                    emailFormData: values?.emailFormData,
                    attachment_key: uploadedFileName,
                    attachment_name: uploadedFileName,
                    date_of_intake: values?.date_of_intake,
                }
            }

            const response = await createReport({ data: body, clientId }).unwrap()


            refetch()
            successMessageToast(response?.message)
            setSubmitting(false);
            if (!values?.saveForLater) {
                navigate(VIEW_HOME_EDUCATION.replace(":id", clientId))
            }
        } catch (error) {
            setSubmitting(false);
            console.log('error', error)
        }
    };

    const handleViewPdf = (values) => {
        const selectedGuardians = data?.client_detail?.client_guardian_mapping?.length > 0 &&
            [...data.client_detail.client_guardian_mapping]
                .map((guardian) => {
                    const id = guardian?.client_guardian?.id;
                    const role = guardian?.client_guardian?.client_role?.title;

                    const matchedGuardian = values?.parent?.find(
                        (item) => item?.parent_id === id && item?.parent_absent == "no"
                    );

                    if (matchedGuardian) {
                        return {
                            ...guardian,
                            key: matchedGuardian?.role  // or matchedGuardian.role
                        };
                    }

                    return null;
                })
                .filter(Boolean);

        const pdfData = {
            lastname: data?.lastname,
            firstname: data?.firstname,
            city_town: data?.client_detail?.city_town,
            dob: dateFormat(data?.client_detail?.dob, dobFormat),
            age: getAge(data?.client_detail?.dob),
            grade: data?.client_detail?.grade,
            reportAreas: values?.screening_results,
            schoolName: data?.client_detail?.client_school_detail?.client_school?.name,
            schoolLocation: data?.client_detail?.client_school_detail?.client_school?.location,
            screening_date: moment(values?.screening_date).format("MMMM D, YYYY"),
            selectedGuardians,
            reportDate: moment(new Date()).format("MMMM D, YYYY"),
            parent_report: values?.parent_report,
            recommendations: values?.recommendations,
            date_of_intake: values?.date_of_intake,
        }

        const doc = (
            <IntakePdfDocV2
                data={pdfData}
            />
        )

        setDocument(doc)
        setPdfModal(true)

    };

    useEffect(() => {
        if (data) {
            const parent = data?.client_detail?.client_guardian_mapping && [...data?.client_detail?.client_guardian_mapping]?.map((guardian, index) => {
                const slug = "parent"
                if (slug !== (clientType === "home_education" ? "parent" : "teacher")) {
                    return null;
                }
                if ([0, 1].includes(index)) {
                    return ({ parent_id: guardian?.client_guardian?.id, parent_absent: "yes" })
                }
            }).filter(Boolean)

            const intakeReport = intakeData?.intakeReport?.[0]

            setInitialValues((prev) => ({
                ...prev,
                parent: intakeReport?.parent ? intakeReport?.parent : parent,
                parent_report: intakeReport?.parent_report || "",
                recommendations: intakeReport?.recommendations || "",
                date_of_intake: moment(intakeReport?.date_of_intake || new Date()).format("YYYY-MM-DD"),
            }))
        }

    }, [data])

    console.log("datadatadata",data);
    

    return (
        <>
            <section className="ReportSec schooldeschargeInput proxima container-discharge-screen py-3 position-relative">
                <Container fluid>
                    <div style={{ maxWidth: "80%", margin: "0 auto" }}>
                        <Formik
                            initialValues={initialValues}
                            onSubmit={handleSubmitStep}
                            validationSchema={intakeFormSchema}
                            enableReinitialize
                        >
                            {({ handleSubmit, values, errors, touched, setFieldValue, submitForm }) => ( 
                                <Form onSubmit={handleSubmit}>
                                    <ViewPdfModal publishPdfCheckbox={true} isPopup={true} show={pdfModal} clientType={clientType} setShow={setPdfModal} doc={document} handleSubmit={submitForm} guardianList={data?.client_detail?.client_guardian_mapping} data={data} />
                                    <PdfPublishModal publishPdfCheckbox={true} show={publishPdfModal} setShow={setPublishPdfModal} clientType={clientType} doc={document} handleSubmit={submitForm} guardianList={data?.client_detail?.client_guardian_mapping} />
                                    {(isLoading || intakeDataLoading) ? (
                                        <LoadingIndicator />
                                    ) : isError ? (
                                        <ErrorComponent />
                                    ) : (
                                        <Row>
                                            <Col lg="12" className="my-2">
                                                {console.log('formik values', values)}
                                                <div className="bg-white">
                                                    <>
                                                        {(isFetching || submitting || intakeDataFetching) && <LoadingOverlay />}
                                                        <div className="formBody reports-v2">
                                                            {/* <h5 className="section-title mb-0 border-0" style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "1px" }}>Speech Language Pathology</h5> */}
                                                            <p style={{ fontSize: "20px", marginTop: "5px", color: "#000" }}>Home Education Intake Session Report</p>
                                                            <div
                                                                className="mt-4 client-view"
                                                            // style={{ borderBottom: "2px dashed #6c6c6c" }}
                                                            >


                                                                <h5 className="section-title">CLIENT INFORMATION</h5>
                                                                <div className="mb-3 d-flex align-items-center" style={{ gap: "200px" }}>
                                                                    <div style={{ width: "50%" }}>
                                                                        <div style={{ width: "100%" }}>
                                                                            <label className="discharge-screen-label">Last Name</label>
                                                                            <input className="readonly-box" readOnly value={data?.lastname} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex gap-3" style={{ width: "50%" }}>
                                                                        <div style={{ width: "100%" }}>
                                                                            <label className="discharge-screen-label">Birth Date</label>
                                                                            <div className="readonly-box d-flex align-items-center">
                                                                                <input style={{ outline: "none" }} className="border-0 w-100" readOnly value={dateFormat(data?.client_detail?.dob, dobFormat)} />
                                                                                <img width={14} height={16} src={date_img} alt="date_img" />
                                                                            </div>
                                                                        </div>
                                                                        <div style={{ width: "50%" }}>
                                                                            <label className="discharge-screen-label">Age</label>
                                                                            <div className="mt-2 proxima">{getAge(data?.client_detail?.dob)}</div>
                                                                        </div>
                                                                    </div>
                                                                    {/* <div style={{ width: "30%" }}>
                                                                        <label className="discharge-screen-label">City/Town</label>
                                                                        <input className="readonly-box" readOnly value={data?.client_detail?.city_town} />
                                                                    </div>
                                                                    <div style={{ width: "20%" }}>
                                                                        <label className="discharge-screen-label">Date of Report</label>
                                                                        <div className="readonly-box d-flex align-items-center">
                                                                            <input style={{ outline: "none" }} className="border-0 w-100" readOnly value={moment().format("YYYY-MM-DD")} />
                                                                            <img width={14} height={16} src={date_img} alt="date_img" />
                                                                        </div>
                                                                    </div> */}
                                                                </div>

                                                                <div className="mb-3 d-flex align-items-start" style={{ gap: "200px" }}>
                                                                    <div style={{ width: "50%" }}>
                                                                        <div style={{ width: "100%" }} className="mb-3">
                                                                            <label className="discharge-screen-label">First Name</label>
                                                                            <input className="readonly-box" readOnly value={data?.firstname} />
                                                                        </div>
                                                                        <div style={{ width: "100%" }}>
                                                                            <label className="discharge-screen-label">City</label>
                                                                            <input className="readonly-box" readOnly value={data?.client_detail?.city_town} />
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex gap-3" style={{ width: "50%" }}>
                                                                        <div style={{ width: "100%" }}>
                                                                            <label className="discharge-screen-label">Grade</label>
                                                                            <input className="readonly-box normal-grade" readOnly value={data?.client_detail?.grade} />
                                                                        </div>
                                                                        <div style={{ width: "100%" }}>
                                                                            <label className="discharge-screen-label">Date of Intake</label>
                                                                            <div className="readonly-box d-flex align-items-center">
                                                                                {/* <input name="" style={{ outline: "none" }} className="border-0 w-100" value={dateFormat(intakeData?.date_of_intake, dobFormat)} type="date" /> */}
                                                                                <AppInputField
                                                                                    name="date_of_intake"
                                                                                    type="date"
                                                                                    style={{ outline: "none", border: "none" }}
                                                                                />
                                                                                {/* <img width={14} height={16} src={date_img} alt="date_img" /> */}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                {data?.client_detail?.client_guardian_mapping?.length > 0 ?
                                                                    [...data?.client_detail?.client_guardian_mapping] // clone the array
                                                                        .map((guardian, index) => {
                                                                            const slug = "parent"
                                                                            if (slug !== (clientType === "home_education" ? "parent" : "teacher")) {
                                                                                return null;
                                                                            }
                                                                            if ([0, 1].includes(index)) {
                                                                                return (
                                                                                    <div className="mt-5">
                                                                                        <GuardianDetailList
                                                                                            previewMode={previewMode}
                                                                                            key={index}
                                                                                            index={index}
                                                                                            guardian={guardian}
                                                                                            slug={slug}
                                                                                            values={values}
                                                                                        />
                                                                                    </div>
                                                                                );
                                                                            }
                                                                            else {
                                                                                return
                                                                            }
                                                                        }) : <ReportsNoRecordMessage msg="No teacher is currently assigned to this client." />
                                                                    // <ReportsNoRecordMessage msg="No teacher is currently assigned to this client." />
                                                                }


                                                                <Row className="justify-content-between mt-3">
                                                                    <Col lg="12">
                                                                        <h5 className="section-title mb-0">MEETING INFORMATION</h5>
                                                                    </Col>
                                                                </Row>
                                                                <div className="py-2 reports-v2 position-relative">
                                                                    {
                                                                        intakeData?.template?.map((item) => (
                                                                            <>
                                                                                <div>
                                                                                    <h6 class="m-0 proxima themeBlue fw-bold text-uppercase mt-4" style={{ fontSize: "12px", borderBottom: "0.75px solid #000" }}>{item?.question}</h6>
                                                                                    <Row className={`reports-v2-question`}>

                                                                                        <Col lg="4 py-3">
                                                                                            <p style={{ fontStyle: "italic", color: "#071E3E" }}>{item?.placeholder}</p>
                                                                                        </Col>
                                                                                        <Col lg="8 py-3">
                                                                                            <div className="ck-editor-wrapper">
                                                                                                <CustomEditor limit={item?.id == 87 ? 5000 : 3000} previewMode={previewMode} name={item?.id == 87 ? `parent_report` : `recommendations`} />
                                                                                            </div>
                                                                                        </Col>

                                                                                    </Row>
                                                                                </div>
                                                                            </>
                                                                        ))
                                                                    }


                                                                </div>



                                                            </div>
                                                            <div className="">
                                                            </div>
                                                        </div>
                                                    </>
                                                </div>
                                            </Col>

                                            <Col lg="12" className="my-4">
                                                {/* <ReportError /> */}
                                                <div className='d-flex gap-3 align-items-center justify-content-end'>
                                                    <button
                                                        type="button"
                                                        className="d-flex align-items-center gap-2 justify-content-center preview-discharge-screen"
                                                        // isLoading={submittingStep}
                                                        disabled={isFetching || submitting || intakeDataFetching}
                                                        onClick={() => handleViewPdf(values)}
                                                    >
                                                        <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M0 0.777778C0 0.571498 0.0842854 0.373667 0.234315 0.227806C0.384344 0.0819442 0.587827 0 0.8 0H15.2C15.4122 0 15.6157 0.0819442 15.7657 0.227806C15.9157 0.373667 16 0.571498 16 0.777778V13.2222C16 13.4285 15.9157 13.6263 15.7657 13.7722C15.6157 13.9181 15.4122 14 15.2 14H0.8C0.587827 14 0.384344 13.9181 0.234315 13.7722C0.0842854 13.6263 0 13.4285 0 13.2222V0.777778ZM1.6 1.55556V12.4444H14.4V1.55556H1.6ZM3.2 3.11111H4.8V4.66667H3.2V3.11111ZM4.8 6.22222H3.2V7.77778H4.8V6.22222ZM3.2 9.33333H4.8V10.8889H3.2V9.33333ZM12.8 3.11111H6.4V4.66667H12.8V3.11111ZM6.4 9.33333H12.8V10.8889H6.4V9.33333ZM12.8 6.22222H6.4V7.77778H12.8V6.22222Z" fill="white" />
                                                        </svg>

                                                        Preview
                                                    </button>
                                                    <>
                                                        <LoadingButton
                                                            onClick={() => setFieldValue('saveForLater', true)}
                                                            type="submit"
                                                            className="d-flex align-items-center justify-content-center save-discharge-screen"
                                                            disabled={previewMode || isFetching || submitting || intakeDataFetching}
                                                        // isLoading={(values?.saveForLater && submitting)}
                                                        >
                                                            Save
                                                        </LoadingButton>

                                                        <LoadingButton
                                                            // onClick={() => { setFieldValue('saveForLater', false) }}
                                                            onClick={() => { setFieldValue('saveForLater', false); setPublishPdfModal(true) }}
                                                            type="button"
                                                            className="d-flex align-items-center gap-2 justify-content-center discharge-screen"
                                                            disabled={previewMode || isFetching || submitting || intakeDataFetching}
                                                        // isLoading={(!values?.saveForLater && submitting)}
                                                        >
                                                            SUBMIT & Export
                                                            <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M9.68197 3.24568L8.85675 0.5H10.2193L14 4.29259V4.70741L10.2193 8.5H8.85675L9.68197 5.75432H0V3.24568H9.68197Z" fill="white" />
                                                            </svg>
                                                        </LoadingButton>

                                                    </>
                                                </div>
                                            </Col>

                                        </Row>
                                    )}
                                </Form>
                            )}
                        </Formik>
                    </div>
                </Container>
            </section>
        </>
    );
};

export default IntakeReportV2;